export function doPriceAddition(price1, price2) {
  if (price1 === undefined || price1 === null || price2 === undefined || price2 === null) {
    return undefined;
  }

  const sign1 = Math.sign(price1);
  const sign2 = Math.sign(price2);

  const centsSumWithSign = Math.round((price1 % 1) * 100) + Math.round((price2 % 1) * 100);
  const signCents = Math.sign(centsSumWithSign);
  const centsSum = Math.abs(centsSumWithSign);
  const centsSumWholes = Math.floor(centsSum / 100);

  const finalCalc =
    sign1 * Math.floor(Math.abs(price1)) +
    sign2 * Math.floor(Math.abs(price2)) +
    signCents * centsSumWholes +
    signCents * ((centsSum - centsSumWholes * 100) / 100);

  if (String(finalCalc).split(".")[1]?.length > 2) {
    return +finalCalc.toFixed(2);
  }

  return finalCalc;
}

export function doMoneyMultiplication(amount, factor) {
  if (amount === undefined || amount === null || factor === undefined || factor === null) {
    return undefined;
  }

  const sign = Math.sign(amount);
  const absoluteAmount = Math.abs(amount);

  const wholes = Math.floor(absoluteAmount);
  const cents = Math.round((absoluteAmount % 1) * 100);

  let unsignedResult = wholes * factor + (cents * factor) / 100;
  if (factor < 1 || factor % 1 !== 0) {
    if (String(unsignedResult).split(".")[1]?.length > 2) {
      unsignedResult = +(unsignedResult).toFixed(2);
    }
  }

  return sign * unsignedResult;
}
